/**
 * Shown when the last unfinished Speedy of a series or a group ends (F-129). Layout from the
 * prototype's circle-complete screen. No motion when reduced motion is set.
 */
import { PartyPopper } from 'lucide-react';

export function SpeedyCelebration({
  kind,
  name,
  onClose,
  onReplay,
}: {
  kind: 'series' | 'group';
  name: string;
  onClose: () => void;
  onReplay: () => void;
}) {
  return (
    <div className="absolute inset-0 z-30 flex items-center justify-center bg-black/80 p-6 text-center text-white" role="dialog" aria-label="All done">
      <div className="max-w-xs space-y-4">
        <PartyPopper className="mx-auto h-12 w-12 motion-safe:animate-bounce" aria-hidden />
        <p className="text-lg font-semibold">
          You've watched every Speedy in {kind === 'series' ? `the series ${name}` : name}
        </p>
        <div className="flex justify-center gap-2">
          <button type="button" onClick={onReplay} className="min-h-[44px] rounded-full border border-white/40 px-4 text-sm font-semibold">Watch again</button>
          <button type="button" onClick={onClose} className="min-h-[44px] rounded-full bg-white px-4 text-sm font-semibold text-black">Done</button>
        </div>
      </div>
    </div>
  );
}
